export default __webpack_public_path__ + "static/media/mais-vida-highlight.c3afce74.svg";